import { render } from "./PowderReportView.vue?vue&type=template&id=a7abfb32&scoped=true"
import script from "./PowderReportView.vue?vue&type=script&lang=js"
export * from "./PowderReportView.vue?vue&type=script&lang=js"

import "./PowderReportView.vue?vue&type=style&index=0&id=a7abfb32&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7abfb32"]])

export default __exports__